import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { InfoCenterComponent } from './InfoCenter/info-center/info-center.component';
import { OrderStatusComponent } from './OrderStatus/order-status/order-status.component';
import { PricingComponent } from './Pricing/pricing/pricing.component';
import { RmaComponent } from './RMA/rma/rma.component';
import { AdminInfoCenterComponent } from './Admin/info-center/info-center.component';
import { UserActivityComponent } from './Admin/user-activity/user-activity.component';
import { ForgotPasswordComponent } from './shared/components/popups/forgot-password/forgot-password.component';
import { CreateUserComponent } from './Admin/create-user/create-user.component';
import { ResetPasswordComponent } from './Admin/reset-password/reset-password.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { PreviewComponent } from './InfoCenter/preview/preview.component';
import { ManageUsersComponent } from './Admin/manage-users/manage-users.component';
import { QuotesComponent } from './Quotes/quotes/quotes.component';
import { NewsComponent } from './News/news/news.component';
import { NewsUpdatesComponent } from './Admin/news-updates/news-updates.component';
import { VerifyEmailComponent } from './admin/verify-email/verify-email.component';
import { ToloUComponent } from './tolo-u/tolo-u.component';

export const appRoutes: Routes = [
  { path: '', component: HomeComponent, pathMatch: 'full' },
  { path: 'portal', component: HomeComponent },
  { path: 'PCMSalesPortal81', component: HomeComponent},
  { path: 'dashboard', component: DashboardComponent},
  { path: 'pricing', component: PricingComponent },
  { path: 'orderstatus', component: OrderStatusComponent },
  { path: 'quotes', component: QuotesComponent},
  { path: 'rma', component: RmaComponent },
  { path: 'infocenter', component: InfoCenterComponent },
  //{ path: 'admininfocenter', component: AdminInfoCenterComponent },
  { path: 'admin/useractivity', component: UserActivityComponent },
  { path: 'admin/manageusers', component: ManageUsersComponent },  
  { path: 'createuser', component: CreateUserComponent },
  { path: 'resetpassword', component: ResetPasswordComponent },
  { path: 'resetpassword/:id', component: ResetPasswordComponent },
  { path: 'preview/:id', component: PreviewComponent },
  { path: 'news', component: NewsComponent },
  { path: 'adminnews', component: NewsUpdatesComponent },
  { path: 'edituser', component: CreateUserComponent },
  { path: 'verifyemail/:id', component: VerifyEmailComponent },
  { path: 'tolo-u', component: ToloUComponent }
];
